<template>
  <div class="header">
    <img src="@/assets/icon/logo_flipaiot.png" class="logo" />
    <div class="Quadrant firstQuadrant">
      <switchBtn class="titleBtn" :curPage="curPage" />
      <!-- <div @click="linkTo">
        <img src="@/assets/switch_btn.png" />
      </div> -->
    </div>
    <div class="Quadrant secondQuadrant">
      <div class="titleBtn" @click="logoutClick">
        <div class="imgBtn">
          <img src="@/assets/icon/login/user_icon.png" />
          <p>{{ userData.name }}</p>
        </div>
      </div>
    </div>
    <div class="Quadrant thirdQuadrant">
      <bleBtn class="titleBtn" />
      <div class="titleBtn">
        <p>E310</p>
      </div>
      <cameraBtn class="titleBtn"/>
    </div>
    <div class="Quadrant forthQuadrant">
      <div class="titleBtn" @click="saveClick">
        <p>{{`Save ${btnTitle}`}}</p>
      </div>
      <uploadBtn :btnText="`Load ${btnTitle}`" class="titleBtn" @fileChange="loadFunction" />
      <div class="titleBtn" @click="clearClick">
        <p>Clear All</p>
      </div>
    </div>
  </div>
</template>

<script>
import bleBtn from '@/components/webBleHandler.vue';
import cameraBtn from '@/components/CameraBtn.vue';
import switchBtn from '@/components/DropDownBtn.vue';
import uploadBtn from '@/components/uploadBtn.vue';
import { mapState } from 'vuex';

export default {
  props: {
    curPage: {
      type: String,
      default() {
        return 'vision';
      },
    },
  },
  components: {
    bleBtn,
    uploadBtn,
    cameraBtn,
    switchBtn,
  },
  computed: {
    ...mapState(['userData']),
    btnTitle() {
      switch (this.curPage) {
        case 'vision':
          return 'AI Vision';
        case 'chart':
          return 'DFP';
        default:
          return 'DFP';
      }
    },
  },
  methods: {
    linkTo() {
      this.$emit('linkTo');
    },
    saveClick() {
      this.$emit('saveClick');
    },
    clearClick() {
      this.$emit('clearClick');
    },
    loadFunction(result) {
      this.$emit('loadFunction', result);
    },
    logoutClick() {
      this.$emit('logoutClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 160px;
  width: 100%;
  background-image: linear-gradient(to right, #39e2cf, #35b6e6);
  position: relative;

  .logo {
    margin-top: 30px;
  }

  .Quadrant {
    position: absolute;
    display: flex;
  }
  .firstQuadrant {
    right: 16px;
    top: 15px;
    div {
      cursor: pointer;
    }
  }
  .secondQuadrant {
    left: 16px;
    top: 15px;
  }
  .thirdQuadrant {
    left: 16px;
    bottom: 10px;
  }
  .forthQuadrant {
    right: 8px;
    bottom: 10px;
  }
  .titleBtn {
    cursor: pointer;
    position: relative;
    align-items: center;
    justify-content: center;
    height: 45px;
    display: flex;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.3);
    min-width: 100px;
    padding: 0px 15px;
    margin-right: 8px;
    p {
      display: inline-block;
      font-family: Arial;
      font-size: 15px;
      color: #ffffff;
      margin-bottom: 0;
    }
    .imgBtn {
      display: flex;
      line-height: 24px;
      min-width: 100px;
      align-items: center;
      img {
        height: 24px;
      }
      p {
        padding: 0 6px;
        flex: 1;
        line-height: 35px;
      }
    }
  }
}
</style>
